import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { usePos } from "../context/PosContext";

export function useData(path) {
  const { selectedPos } = usePos();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(() => {
    setLoading(true);
    const sep = path.includes("?") ? "&" : "?";
    const url = selectedPos && selectedPos !== "all" ? `${path}${sep}pos_id=${selectedPos}` : path;
    api
      .get(url)
      .then(({ data }) => setData(data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [path, selectedPos]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, refetch, setData };
}
